// src/hooks/useLoadAvailablePlans.ts
import { useState, useEffect, useCallback } from "react";
import { useGetStatisticsQuery } from "../redux/api";

export const useLoadStatistic = (projectId: string) => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetStatisticsQuery(
        { project_id: projectId },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadStatistic = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadStatistic, isLoading, data, isError };
};